import { IconButton as MUIIconButton } from "@mui/material";
import { createLink } from "@tanstack/react-router";

const RouterIconButton = createLink(MUIIconButton);

export default RouterIconButton;
